"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveDirectoryAuthService = void 0;
class ActiveDirectoryAuthService {
    constructor(tokenService, httpService, url) {
        this.tokenService = tokenService;
        this.httpService = httpService;
        this.url = url;
    }
    async login(data) {
        try {
            const response = await this.httpService.post(`${this.url}/api/auth/mfa-user-auth`, {
                data,
            });
            return response.data;
        }
        catch (error) {
            this.httpService.onHttpErrorStatus(error, {
                401: () => {
                    throw Error(data.pin ? 'Incorrect PIN' : 'Incorrect username or password');
                },
            });
            throw Error(error.message || 'Something went wrong.');
        }
    }
    async requestMfa({ options, useBackup, username, password, }) {
        let mfa = options.find((option) => {
            return option.isPrimary === true;
        });
        if (!mfa || useBackup) {
            mfa = options.find((option) => {
                return option.isDefault === true;
            });
        }
        if (!mfa) {
            throw new Error('Could not find valid MFA option');
        }
        const url = `${this.url}/api/auth/mfa`;
        const mfaMethod = mfa.isDefault ? 'DEFAULT' : mfa.uuid;
        try {
            await this.httpService.post(url, {
                data: { mfaMethod, username, password },
            });
            return mfa;
        }
        catch (error) {
            throw Error(error.message || 'Something went wrong');
        }
    }
    isNoAuthMode() {
        return process.env.NODE_ENV === 'development' && process.env.NO_AUTH_MODE === '1';
    }
    isAuthenticated() {
        if (this.isNoAuthMode()) {
            return true;
        }
        return !this.tokenService.isTokenExpired();
    }
    getUuid() {
        if (!this.isAuthenticated()) {
            return null;
        }
        const token = this.tokenService.getTokenContent();
        const payload = token && token.payload;
        const user = payload && payload.user;
        const uuid = user && user.uuid;
        return uuid || null;
    }
}
exports.ActiveDirectoryAuthService = ActiveDirectoryAuthService;
//# sourceMappingURL=ActiveDirectoryAuthService.js.map